module.exports = __webpack_public_path__ + "media/images/gse_file-aded73b5b9febe70b28671cfb5e973aa.png";